module.exports = __webpack_public_path__ + "static/media/skill.5edc3ff0.png";